import React from 'react';
import ReactDOM from 'react-dom';
import ColonyAdmin from '@colonynetworks/colony-app';

const SPEC_URL = `https://${process.env.BASE_URL}/v3/timescale`;

ReactDOM.render(<ColonyAdmin specUrl={SPEC_URL} showAllResources={true} />, document.getElementById('root'));
